import { TOGGLE_STATES } from '../constants';
import { selectToggleState } from '../selectors';
import {
	setReportCounts,
  setToggleState,
	setRefReportAggs,
} from './actions'


const thunkSetRefReportAggs = (reportAggs = []) => (dispatch) => {
	const totalCount = reportAggs.length;
	const countGhostReports = reportAggs.filter(r => r.isGhostReport).length;
	const countExistingReports = totalCount - countGhostReports;
  dispatch(setRefReportAggs(reportAggs));
	dispatch(setReportCounts({ countExistingReports, countGhostReports }));
	if (!countGhostReports) {
		dispatch(setToggleState(TOGGLE_STATES.ALL));
	}
}

const thunkToggle = () => (dispatch, getState) => {
	const currentToggleState = selectToggleState(getState());

	switch(currentToggleState) {
		case TOGGLE_STATES.ALL:
			dispatch(setToggleState(TOGGLE_STATES.GHOST));
			break;
		case TOGGLE_STATES.GHOST:
			dispatch(setToggleState(TOGGLE_STATES.EXISTING));
			break;
		case TOGGLE_STATES.EXISTING:
			dispatch(setToggleState(TOGGLE_STATES.ALL));
			break;
		default:
			dispatch(setToggleState(TOGGLE_STATES.ALL));
	}
}

const thunkSetToggleStateAll = () => (dispatch) => {
	dispatch(setToggleState(TOGGLE_STATES.ALL));
}

export { thunkSetRefReportAggs, thunkToggle, thunkSetToggleStateAll };

export default { thunkSetRefReportAggs, thunkToggle, thunkSetToggleStateAll };
